import { render, staticRenderFns } from "./EvaluationDetailList.vue?vue&type=template&id=83c90628&scoped=true"
import script from "./EvaluationDetailList.vue?vue&type=script&lang=js"
export * from "./EvaluationDetailList.vue?vue&type=script&lang=js"
import style0 from "./EvaluationDetailList.vue?vue&type=style&index=0&id=83c90628&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c90628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83c90628')) {
      api.createRecord('83c90628', component.options)
    } else {
      api.reload('83c90628', component.options)
    }
    module.hot.accept("./EvaluationDetailList.vue?vue&type=template&id=83c90628&scoped=true", function () {
      api.rerender('83c90628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/evaluationDetail/EvaluationDetailList.vue"
export default component.exports